import {
  AuthResponse,
  LoginCredentials,
  RegisterCredentials,
  ResetPasswordCredentials,
  User,
} from '@auth/types/auth';
import axios from '@core/api/axiosConfig';

export const authApi = {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const { data } = await axios.post('/auth/login', credentials);
    if (data.token) {
      localStorage.setItem('token', data.token);
    }
    if (data.refreshToken) {
      localStorage.setItem('refreshToken', data.refreshToken);
    }
    return data;
  },

  async register(credentials: RegisterCredentials): Promise<AuthResponse> {
    const { data } = await axios.post('/auth/register', credentials);
    if (data.token) {
      localStorage.setItem('token', data.token);
    }
    if (data.refreshToken) {
      localStorage.setItem('refreshToken', data.refreshToken);
    }
    return data;
  },

  async logout(token: string): Promise<void> {
    await axios.post('/auth/logout', { token });
  },

  async validateToken(): Promise<User> {
    const { data } = await axios.get('/auth/validate-token');
    return data.user;
  },

  async forgotPassword(email: string): Promise<void> {
    await axios.post('/auth/forgot-password', { email });
  },

  async resetPassword(credentials: ResetPasswordCredentials): Promise<void> {
    await axios.post('/auth/reset-password', credentials);
  },

  async pingServer(): Promise<void> {
    await axios.get('/health');
  },
};
